export enum Feature {
  INSTANCE_STOP = 'instance_stop',
  INSTANCE_START = 'instance_start',
  DATABASE_SNAPSHOT = 'database_snapshot',
  DATABASE_ARCHIVE = 'database_archive',
  SANITY_TEST = 'sanity_test',
  EF_TEST = 'ef_test',
  RVT_TEST = 'rvt_test',
  COB = 'cob',
  JUMPBOX = 'jumpbox',
  PARALLEL_DR = 'parallel_dr',
}

export enum FeatureDatazone {
  PII = 'pii',
  NONPII = 'nonpii',
  LIVE = 'prod'
}

export enum Action {
  ENABLED = 'enabled',
  MODIFIABLE = 'modifiable'
}

export enum FeatureAttributes {
  DATAZONE = 'dataZone'
}
